module.exports = __webpack_public_path__ + "static/img/banner-right.1e8f9277.png";